// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","iconClassName":"styles_iconClassName__UV2L6"};